export const firebaseConfig = {
  "apiKey": "AIzaSyDuRTTluAFufmvw1zxGH6fsyEHmmbu8IHI",
  "authDomain": "antimatter-dimensions-a00f2.firebaseapp.com",
  "databaseURL": "https://antimatter-dimensions-a00f2.firebaseio.com",
  "projectId": "antimatter-dimensions-a00f2",
  "storageBucket": "antimatter-dimensions-a00f2.appspot.com",
  "messagingSenderId": "904798020003",
  "appId": "1:904798020003:web:d1448dcb2dedd8b5",
};